import React, { useState } from "react";
import { SignStyled } from "./SignStyled";
import { MoonLoader } from "react-spinners";

const Sign = () => {
    const [name, setName] = useState("");
    const [role, setRole] = useState("");
    const [phone, setPhone] = useState("");
    const [whatsapp, setWhatsapp] = useState("");
    const [image, setImage] = useState(null); // imagem do pc
    const [imageLink, setImageLink] = useState(""); // link da imagem

    const [isTelephone, setIsTelephone] = useState(false);
    const [hasWhatsapp, setHasWhatsapp] = useState(false);

    const [isLoading, setIsLoading] = useState(false);


    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
            const img = new Image();
            img.onload = async () => {
                const maxSize = 300;
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                canvas.width = canvas.height = maxSize;

                const size = Math.min(img.width, img.height);
                const offsetX = (img.width - size) / 2;
                const offsetY = (img.height - size) / 2;

                ctx.drawImage(img, offsetX, offsetY, size, size, 0, 0, maxSize, maxSize);

                const circularCanvas = document.createElement('canvas');
                const circularCtx = circularCanvas.getContext('2d');
                circularCanvas.width = circularCanvas.height = maxSize;

                circularCtx.beginPath();
                circularCtx.arc(maxSize / 2, maxSize / 2, maxSize / 2, 0, Math.PI * 2);
                circularCtx.closePath();
                circularCtx.clip();

                circularCtx.drawImage(canvas, 0, 0);

                const dataUrl = circularCanvas.toDataURL('image/png', 0.5);

                const imageSize = dataUrl.length;
                console.log(`Tamanho da imagem base64: ${imageSize}`);

                setImage(dataUrl);
                setIsLoading(true);
                await uploadToImgur(dataUrl);
            };

            img.src = reader.result;
        };

        if (file) {
            reader.readAsDataURL(file);
        }
    };



    const uploadToImgur = async (base64Image) => {
        console.log("teste");
        try {
            const response = await fetch('https://eolr6wxwx8k5vhw.m.pipedream.net', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ image: base64Image })
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const textResponse = await response.text();
            console.log(textResponse);
    
            const urlMatch = textResponse.match(/https:\/\/i\.imgur\.com\/\S+\.png/);
            if (urlMatch && urlMatch[0]) {
                const imageUrl = urlMatch[0];
                setImageLink(imageUrl);
            } else {
                console.error('Image URL not found in response:', textResponse);
            }
        } catch (error) {
            console.error('Failed to fetch:', error);
        } finally {
            setIsLoading(false); // Finaliza o carregamento
        }
    };
    
    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');

        if (isTelephone) {
            value = value.slice(0, 10);
            if (value.length > 6) {
                value = value.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
            } else if (value.length > 2) {
                value = value.replace(/(\d{2})(\d{0,4})/, '($1) $2');
            } else {
                value = value.replace(/(\d{0,2})/, '($1');
            }
        } else {
            value = value.slice(0, 11);
            if (value.length > 7) {
                value = value.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
            } else if (value.length > 2) {
                value = value.replace(/(\d{2})(\d{0,5})/, '($1) $2');
            } else {
                value = value.replace(/(\d{0,2})/, '($1');
            }
        }

        setPhone(value);
    };

    const handleWhatsappChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');
    
        value = value.slice(0, 11);
        if (value.length > 7) {
            value = value.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
        } else if (value.length > 2) {
            value = value.replace(/(\d{2})(\d{0,5})/, '($1) $2');
        } else if (value.length > 0) {
            value = value.replace(/(\d{0,2})/, '($1');
        }
    
        setWhatsapp(value);
        setHasWhatsapp(value.length > 0);
    };

    const handleCheckboxChange = () => {
        setIsTelephone(!isTelephone);
        setPhone("");
    };

    const openWhatsappChat = () => {
        const cleanedNumber = whatsapp.replace(/\D/g, '');
        const url = `https://wa.me/55${cleanedNumber}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const openLinkedin = () => {
        const url = "https://www.linkedin.com/company/amigotechsa/mycompany/verification/";
        window.open(url);
    };

    const openInstagram = () => {
        const url = "https://www.instagram.com/amigotech/";
        window.open(url);
    };

    const openSite = () => {
        const url = "https://www.amigotech.com.br/";
        window.open(url);
    };

    const handleDownload = () => {
        const whatsappIconUrl = "https://i.imgur.com/2ZEZCqa.png";
        let whatsappContent = '';

        if (hasWhatsapp) {
            const cleanedNumber = whatsapp.replace(/\D/g, '');
            const url = `https://wa.me/55${cleanedNumber}`;
            whatsappContent = `<a href="${url}" target="_blank"><img src="${whatsappIconUrl}" alt="WhatsApp Icon" style="width: 15px; height: 16px; margin-left: 5px;" /></a>`;
        }

        const htmlContent = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
            <link
              href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&family=Lato:wght@100;300;400&family=Leckerli+One&display=swap"
              rel="stylesheet"
            />
            <title>Assinatura de Email</title>
            <style>
                body {
                    margin: 0;
                    padding: 0;
                }


                a {
                    text-decoration: none;
                    color: transparent

                }

                .container {
                    width: 100%;
                    max-width: 600px;
                    font-family: "Inter", Arial, sans-serif;
                    padding-top: 20px;
                }
                .profile-image {
                    width: 100px;
                    height: 100px;
                    clip-path: circle();
                }

                .contact-info .name {
                    font-weight: 600;
                    font-size: 16px;
                    margin-bottom: 5px;
                }
                .contact-info .role {
                    color: rgb(78, 82, 85);
                    font-size: 12px;
                }
                .contact-info .phone {
                    font-weight: bold;
                    margin-top: 36px;
                    display: flex;
                    align-items: center;
                }
                .whatsapp-icon {
                    width: 16px;
                    height: 17px;
                    margin-left: 5px;
                }
                .social-links {
                    margin-top: 20px;
                    width: 100%;
                    justify-content: space-between;
                    align-items: center;
                }

                .social-icons {
                    text-align: right;
                }

                .social-icons img {
                    width: 14px;
                    height: 14px;
                    margin-left: 10px;
                }

                .company-logo img {
                    width: 80px;
                    height: 18px;
                }
                .separator {
                    border-top: 1px solid #ccc;
                    margin-top: 20px;
                }
                .profile-section {
                    display: flex;
                    align-items: center;
                    margin-bottom: 16px;
                }
                .contact-details {
                    display: flex;
                    flex-direction: column;
                }

            </style>
        </head>
        <body>
            <table class="container" cellpadding="0" cellspacing="0" border="0">
                <tr>
                    <td valign="top">
                        <table cellpadding="0" cellspacing="0" border="0">
                            <tr class="profile-section">
                                <td>
                                    <img src="${imageLink}" alt="Profile Image" class="profile-image" />
                                </td>
                                <td style="width: 20px;"></td> <!-- Espaço entre a imagem e as informações de contato -->
                                <td class="contact-info">
                                    <div class="contact-details">
                                        <div class="teste">
                                            <div class="name">${name}</div>
                                            <div class="role">${role}</div>
                                            <div class="phone">${phone}<span class="whatsapp-icon">${whatsappContent}</span></div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3" class="separator">
                                    <table class="social-links" cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                                        <tr>
                                            <td class="company-logo">
                                                <img class="company-logo" src="https://files.appamigo.com.br/images/__assinatura-emails__/Amigo.png" alt="Company Logo" />
                                            </td>
                                            <td class="social-icons">
                                                <a href="https://www.amigotech.com.br/" target="_blank">
                                                    <img src="https://files.amigotech.com.br/images/__assinatura-emails__/web.png" alt="Website Icon" />
                                                </a>
                                                <a href="https://www.instagram.com/amigotech/" target="_blank">
                                                    <img src="https://files.amigotech.com.br/images/__assinatura-emails__/ig.png" alt="Instagram Icon" />
                                                </a>
                                                <a href="https://www.linkedin.com/company/amigotechsa/mycompany/verification/" target="_blank">
                                                    <img src="https://files.amigotech.com.br/images/__assinatura-emails__/in.png" alt="LinkedIn Icon" />
                                                </a>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </body>
        </html>
        
        `;

        const blob = new Blob([htmlContent], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
    
        const link = document.createElement('a');
        link.href = url;
        link.download = 'assinatura-email.html';
        document.body.appendChild(link);
        link.click();
    
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
    };

    return (
        <SignStyled>
            <SignStyled.TitleWrapper>
                <SignStyled.Title>1. Gere sua assinatura</SignStyled.Title>
                <SignStyled.SubTitle>Preencha os dados para gerar o arquivo da sua assinatura de e-mail.</SignStyled.SubTitle>
            </SignStyled.TitleWrapper>

            <SignStyled.FormWrapper>
                <SignStyled.InputWrapper>
                    <SignStyled.InputText>Foto de Perfil <SignStyled.Asterisco /></SignStyled.InputText>
                    <SignStyled.UploadInputContainer>
                        <SignStyled.UploadLabel htmlFor="upload-input">
                            <SignStyled.UploadIcon />
                            Anexar Imagem
                        </SignStyled.UploadLabel>
                        <SignStyled.UploadInput id="upload-input" onChange={handleImageUpload} />
                        {isLoading && <MoonLoader size={20} color="#008CFF" loading={isLoading} />}
                    </SignStyled.UploadInputContainer>
                </SignStyled.InputWrapper>

                <SignStyled.DesktopDiv>
                    <SignStyled.InputWrapper>
                        <SignStyled.InputText>Nome <SignStyled.Asterisco /></SignStyled.InputText>
                        <SignStyled.TextInput
                            placeholder="Preencha seu nome e sobrenome"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </SignStyled.InputWrapper>

                    <SignStyled.InputWrapper>
                        <SignStyled.InputText>Cargo <SignStyled.Asterisco /></SignStyled.InputText>
                        <SignStyled.TextInput
                            placeholder="Preencha seu cargo"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                        />
                    </SignStyled.InputWrapper>
                </SignStyled.DesktopDiv>

                <SignStyled.DesktopDiv>
                    <SignStyled.InputWrapper>
                        <SignStyled.InputText>Número para contato <SignStyled.Asterisco /></SignStyled.InputText>
                        <SignStyled.TextInput
                            placeholder="Digite apenas números"
                            value={phone}
                            onChange={handlePhoneChange}
                        />
                    </SignStyled.InputWrapper>

                    <SignStyled.InputWrapper>
                        <SignStyled.InputText>Contato para Whatsapp</SignStyled.InputText>
                        <SignStyled.TextInput
                            placeholder="Digite apenas números"
                            value={whatsapp}
                            onChange={handleWhatsappChange}
                        />
                    </SignStyled.InputWrapper>
                </SignStyled.DesktopDiv>

                <SignStyled.CheckboxWrapper>
                    <SignStyled.Checkbox
                        id="telefone-fixo"
                        checked={isTelephone}
                        onChange={handleCheckboxChange}
                    />
                    <SignStyled.CheckBoxText htmlFor="telefone-fixo">Telefone Fixo</SignStyled.CheckBoxText>
                </SignStyled.CheckboxWrapper>
            </SignStyled.FormWrapper>

            <SignStyled.SignatureWrapper>
                <SignStyled.SignatureTitle>Prévia da Assinatura</SignStyled.SignatureTitle>

                <SignStyled.SignContainer>
                    <SignStyled.SignUpperPart>
                        <SignStyled.PhotoContainer hasImage={!!image}>
                            {image ? <SignStyled.Photo src={image} alt="foto" /> : null}
                        </SignStyled.PhotoContainer>
                        <SignStyled.SignDataWrapper>
                            <SignStyled.SignDataUpperPart>
                                <SignStyled.SignName>{name || "Nome de exemplo"}</SignStyled.SignName>
                                <SignStyled.SignRole>{role || "Cargo de exemplo"}</SignStyled.SignRole>
                            </SignStyled.SignDataUpperPart>
                            <SignStyled.SignDataLowerPart>
                                <SignStyled.SignNumber>{phone || "(81) 9 9999-9999"}</SignStyled.SignNumber>
                                {whatsapp && whatsapp.length > 2 && (
                                    <SignStyled.SignWhatsappDiv onClick={openWhatsappChat}>
                                        <SignStyled.SignWhatsappIcon />
                                    </SignStyled.SignWhatsappDiv>
                                )}
                            </SignStyled.SignDataLowerPart>
                        </SignStyled.SignDataWrapper>
                    </SignStyled.SignUpperPart>

                    <SignStyled.SignMidPart></SignStyled.SignMidPart>

                    <SignStyled.SignLowerPart>
                        <SignStyled.AmigoSvg />
                        <SignStyled.RightWrapper>
                            <SignStyled.SiteIcon onClick={openSite} />
                            <SignStyled.InstagramIcon onClick={openInstagram} />
                            <SignStyled.LinkedinIcon onClick={openLinkedin} />
                        </SignStyled.RightWrapper>
                    </SignStyled.SignLowerPart>
                </SignStyled.SignContainer>
            </SignStyled.SignatureWrapper>

            <SignStyled.DownloadButton onClick={handleDownload}>
                <SignStyled.DownloadIcon />
                <SignStyled.DownloadText>Fazer download</SignStyled.DownloadText>
            </SignStyled.DownloadButton>
        </SignStyled>
    );
};

export default Sign;
